import React, { useState } from "react";
import { FaCaretDown, FaCheckSquare, FaRegSquare } from "react-icons/fa";

function AccessandRoles({ formik, isEditMode }) {

  const modules = [
    { label: "Patients", name: "patients" },
    { label: "Appointments", name: "appointments" },
    { label: "Prescriptions", name: "prescriptions" },
    { label: "Billing", name: "billing" },
  ];

  const permTypes = [
    { label: "View", key: "view" },
    { label: "Add", key: "add" },
    { label: "Edit", key: "edit" },
    { label: "Delete", key: "delete" },
  ];

  // Track selected permissions
  const [permissions, setPermissions] = useState({});

  // Toggle single permission
  const togglePermission = (moduleName, permKey) => {
    setPermissions((prev) => ({...prev,[moduleName]: {...prev[moduleName],[permKey]: !prev[moduleName]?.[permKey],},}));
  };



  return (
    <>
      <div className="row">
        <div className="col-12 d-flex flex-column align-items-start">
          <div className="col-12 d-flex">
            <h5
              className="fw-semibold h5-WOeTzEASAL"
              style={{ color: "rgb(43, 81, 147)", marginTop: "1rem" }}
            >
              Access and Roles
            </h5>
          </div>
        </div>

        {/* Original inputs */}
        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Username<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Username"
              value={formik.values.Username}
              name="Username"
              onChange={(e) => {
                const value = e.target.value.replace(/[^a-zA-Z.\s]/g, "");
                formik.setFieldValue("Username", value);
              }}
              disabled={isEditMode}
            />
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Email for Access<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Position/Role"
              value={formik.values.Access}
              name="Access"
              onChange={(e) => formik.setFieldValue("Access", e.target.value)}
              disabled={isEditMode}
            />
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3 position-relative">
            <label className="col-form-label lbl-VLJQLgvYMk">
              System Role<span className="text-danger">*</span>
            </label>
            <div style={{ position: "relative" }}>
              <select
                className="form-control"
                id="systemrole"
                name="systemrole"
                value={formik.values.systemrole}
                onChange={(e) => formik.setFieldValue("systemrole", e.target.value)}
                style={{
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  paddingRight: "2.5rem",
                }}
              >
                <option value="">Select the Options</option>
                <option value="administrator">Administrator</option>
                <option value="manager">Manager</option>
                <option value="staff">Staff</option>
                <option value="doctor">Doctor</option>
                <option value="nurse">Nurse</option>
                <option value="receptionist">Receptionist</option>
              </select>
              <FaCaretDown
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                }}
              />
            </div>
          </div>
        </div>

        <div>
      <h5>Module Permissions</h5>
      <div
        style={{
          border: "1px solid #eee",
          borderRadius: "8px",
          padding: "18px",
          background: "#fff",
          marginTop: 5,
        }}
      >
        {modules.map((module) => (
          <div
            key={module.name}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 14,
              gap: 40,
            }}
          >
            {/* Module Name */}
            <div style={{ minWidth: 120, fontWeight: "500" }}>
              {module.label}
            </div>

            {/* Permission Checkboxes */}
            {permTypes.map((perm) => (
              <div
                key={perm.key}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  minWidth: 90,
                  cursor: "pointer",
                }}
                onClick={() => togglePermission(module.name, perm.key)}
              >
                {permissions[module.name]?.[perm.key] ? (
                  <FaCheckSquare size={18} color="#2B5193" />
                ) : (
                  <FaRegSquare size={18} color="#aaa" />
                )}
                <span>{perm.label}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
      </div>
    </>
  );
}

export default AccessandRoles;
